import path from 'path'
class OpenFile {
  makeFileUrl (appUser, toUrl = '') {
    let url = toUrl ? String(toUrl).trim() : ''

    if (!url) return ''

    if (!url.startsWith('http') && appUser.userPath) {
      url = path.join(appUser.userPath, url)
    }

    return url
  }

  open (appUser, toUrl = '') {
    let url = this.makeFileUrl(appUser, toUrl)

    if (!url) {
      return
    }

    window.open(url, '_blank')
  }
}

export default new OpenFile()
